import React from 'react';

const Illustration = () => (
<svg width="225" height="115" viewBox="0 0 225 115" fill="none" xmlns="http://www.w3.org/2000/svg">
<title>Retailer Information</title>
<g id="Frame 1550">
<g id="Group">
<path id="Vector" d="M164.357 114.938H6.46094V58.2204L108.833 7.57275H164.357V114.938Z" fill="#00489B"/>
<g id="Clip path group">
<mask id="mask0_683_4025" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="6" y="7" width="159" height="108">
<g id="clippath">
<path id="Vector_2" d="M164.357 114.938H6.46094V58.2204L108.833 7.57275H164.357V114.938Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask0_683_4025)">
<g id="Group_2">
<path id="Vector_3" opacity="0.5" d="M164.398 -14.0342H108.18V121.528H164.398V-14.0342Z" fill="#ECF6FF"/>
</g>
</g>
</g>
</g>
<g id="Group_3">
<path id="Vector_4" d="M170.791 0.0869141L108.18 0.463477L0.0683594 53.9354V61.4666L108.18 7.99473L170.791 7.61816V0.0869141Z" fill="#00489B"/>
<g id="Clip path group_2">
<mask id="mask1_683_4025" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="171" height="62">
<g id="clippath-1">
<path id="Vector_5" d="M170.791 0.0869141L108.18 0.463477L0.0683594 53.9354V61.4666L108.18 7.99473L170.791 7.61816V0.0869141Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask1_683_4025)">
<g id="Group_4">
<path id="Vector_6" d="M108.181 -10.0801H-12.9043V71.0691H108.181V-10.0801Z" fill="#02021E"/>
</g>
</g>
</g>
</g>
<g id="Group_5">
<path id="Vector_7" d="M218.924 51.1113H108.18V114.939H218.924V51.1113Z" fill="#00489B"/>
<g id="Clip path group_3">
<mask id="mask2_683_4025" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="108" y="51" width="111" height="64">
<g id="clippath-2">
<path id="Vector_8" d="M218.924 51.1113H108.18V114.939H218.924V51.1113Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask2_683_4025)">
<g id="Group_6">
<path id="Vector_9" opacity="0.5" d="M257.092 48.8521H184.516V119.081H257.092V48.8521Z" fill="#ECF6FF"/>
</g>
</g>
</g>
</g>
<g id="Group_7">
<path id="Vector_10" d="M224.941 43.5801H108.18V51.1113H224.941V43.5801Z" fill="#00489B"/>
<g id="Clip path group_4">
<mask id="mask3_683_4025" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="108" y="43" width="117" height="9">
<g id="clippath-3">
<path id="Vector_11" d="M224.941 43.5801H108.18V51.1113H224.941V43.5801Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask3_683_4025)">
<g id="Group_8">
<path id="Vector_12" d="M184.516 40.5674H102.727V52.8057H184.516V40.5674Z" fill="#02021E"/>
</g>
</g>
</g>
</g>
<path id="Vector_13" opacity="0.5" d="M105.548 103.787H10.7852V107.552H105.548V103.787Z" fill="#D5EDFF"/>
<g id="Group_9">
<path id="Vector_14" d="M100.472 103.786H15.2988V53.9353L100.472 11.7603V103.786Z" fill="#D5EDFF"/>
<g id="Clip path group_5">
<mask id="mask4_683_4025" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="15" y="11" width="86" height="93">
<g id="clippath-4">
<path id="Vector_15" d="M100.472 103.786H15.2988V53.9353L100.472 11.7603V103.786Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask4_683_4025)">
<g id="Group_10">
<path id="Vector_16" d="M-1.3418 104.446L98.0272 -8.38574L111.565 8.55957L14.2639 106.893L-1.3418 104.446Z" fill="white"/>
<path id="Vector_17" d="M19.1855 105.575L102.539 25.6934L102.915 35.484L22.1939 105.764L19.1855 105.575Z" fill="white"/>
</g>
</g>
</g>
</g>
<g id="Group_11">
<path id="Vector_18" d="M159.869 67.2676H131.512V111.173H159.869V67.2676Z" fill="#D5EDFF"/>
<g id="Clip path group_6">
<mask id="mask5_683_4025" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="131" y="67" width="29" height="45">
<g id="clippath-5">
<path id="Vector_19" d="M159.869 67.2676H131.512V111.173H159.869V67.2676Z" fill="white"/>
</g>
</mask>
<g mask="url(#mask5_683_4025)">
<g id="Group_12">
<path id="Vector_20" d="M102.754 122.413L168.866 47.3457L177.872 58.62L113.136 124.042L102.754 122.413Z" fill="white"/>
</g>
</g>
</g>
</g>
<path id="Vector_21" d="M125.667 31.2758C126.03 31.2758 126.03 30.7109 125.667 30.7109C125.304 30.7109 125.304 31.2758 125.667 31.2758Z" fill="#00489B"/>
<path id="Vector_22" d="M133.947 86.4141H133.195V95.8281H133.947V86.4141Z" fill="#02021E"/>
<path id="Vector_23" opacity="0.5" d="M164.398 111.173H126.873V114.938H164.398V111.173Z" fill="#D5EDFF"/>
<g id="Group_13">
<path id="Vector_24" d="M153.129 70.1802H138.253C138.045 70.1802 137.877 70.3488 137.877 70.5567V75.9341C137.877 76.142 138.045 76.3106 138.253 76.3106H153.129C153.337 76.3106 153.505 76.142 153.505 75.9341V70.5567C153.505 70.3488 153.337 70.1802 153.129 70.1802Z" fill="#00489B"/>
<g id="OPEN">
<path id="Vector_25" d="M150.686 72.0518V74.4682H150.33L148.872 72.6245V74.458H148.432V72.0518H148.96L150.249 73.7022V72.0518H150.686Z" fill="white"/>
<path id="Vector_26" d="M145.887 74.458V72.0518H147.833V72.4449H146.34V72.9939H147.23V73.3904H146.34V74.0547H147.968V74.458H145.887Z" fill="white"/>
<path id="Vector_27" d="M143.213 74.458V72.0518H144.54C145.078 72.0518 145.379 72.3127 145.379 72.7872C145.379 73.2515 145.078 73.5362 144.54 73.5362H143.666V74.458H143.213ZM144.516 72.4584H143.666V73.1295H144.516C144.78 73.1295 144.912 72.9939 144.912 72.794C144.912 72.5771 144.783 72.4584 144.516 72.4584Z" fill="white"/>
<path id="Vector_28" d="M141.419 74.4988C140.698 74.4988 140.16 73.9769 140.16 73.255C140.16 72.5331 140.705 72.0112 141.419 72.0112C142.133 72.0112 142.678 72.5331 142.678 73.255C142.678 73.9735 142.133 74.4988 141.419 74.4988ZM141.419 74.0853C141.9 74.0853 142.214 73.7159 142.214 73.255C142.214 72.7975 141.9 72.4247 141.419 72.4247C140.942 72.4247 140.627 72.7975 140.627 73.255C140.627 73.7193 140.939 74.0853 141.419 74.0853Z" fill="white"/>
</g>
</g>
</g>
</svg>

);

export default Illustration;

